import React, { useState } from "react";
import "./Header.css";
import logo from "./../../images/nasif.jpg";
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin,
  FaFacebook,
  FaLinkedinIn,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

function Header() {
  // fixed Header
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    header.classList.toggle("active", window.scrollY > 200);
  });

  // Toogle Menu
  const [Mobile, setMobile] = useState(false);

  return (
    <>
      <header className="header">
        <div className="container d_flex">
          <a className="logo" href="#home">
            <img src={logo} alt="Nasif Jihan" />
          </a>

          <div className="navlink">
            <ul
              className={Mobile ? "nav-links-mobile" : "link f_flex uppercase"}
              onClick={() => setMobile(false)}
            >
              {/*<ul className='link f_flex uppercase {Mobile ? "nav-links-mobile" : "nav-links"} onClick={() => setMobile(false)}'>*/}
              <li>
                <a href="#home">home</a>
              </li>
              <li>
                <a href="#features">features</a>
              </li>
              <li>
                <a href="#skills">skills</a>
              </li>
              <li>
                <a href="#portfolio">portfolio</a>
              </li>
              <li>
                <a href="#resume">resume</a>
              </li>
              <li>
                <a href="#certification">certification</a>
              </li>
              <li>
                <a href="#clients">clients</a>
              </li>
              {/* <li>
                <a href="#blog">blog</a>
              </li> */}
              <li>
                <a href="#contact">contact</a>
              </li>
              <li>
                <a href="https://drive.usercontent.google.com/download?id=1it6xASTSXLcpXJLff4npR3BgHAKsLCx9&export=download">
                  <button class="home-btn btn btn-lg flex justify-center items-center gap-2 btn_shadow">
                    <i class="fas fa-download"></i> Resume
                  </button>
                </a>
              </li>
            </ul>

            <button className="toggle" onClick={() => setMobile(!Mobile)}>
              {Mobile ? (
                <i className="fas fa-times close home-btn"></i>
              ) : (
                <i className="fas fa-bars open"></i>
              )}
            </button>
          </div>
        </div>
      </header>

      {/* Social icons */}
      <div className="social-icon hidden lg:flex fixed flex-col top-[35%] left-0">
        <ul>
          <li className="p-4 w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-5px] duration-300 bg-blue-600">
            <a
              className="flex justify-between items-center w-full text-gray-300"
              href="https://www.linkedin.com/in/nasifjihan/"
              target="_blank"
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>

          <li className="p-4 w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-5px] duration-300 bg-[#333333]">
            <a
              className="flex justify-between items-center w-full text-gray-300"
              href="https://github.com/nasifjihan/"
              target="_blank"
            >
              Github <FaGithub size={30} />
            </a>
          </li>

          <li className="p-4 w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-5px] duration-300 bg-[#3b5998]">
            <a
              className="flex justify-between items-center w-full text-gray-300"
              href="https://www.facebook.com/nasifjihan/"
              target="_blank"
            >
              Facebook <FaFacebook size={30} />
            </a>
          </li>

          <li className="p-4 w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-5px] duration-300 bg-[#6fc2b0]">
            <a
              className="flex justify-between items-center w-full text-gray-300"
              href="mailto:nasifzeehan1@gmail.com"
              target="_blank"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Header;
